export default "__VITE_ASSET__1kQ$$Zuy__"